import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ShopifyEcommerceSolutionsInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Shopify E-commerce Solutions in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Power Your Online Store</Subheading>}
        heading={
          <Heading>
            Shopify <span tw="text-primary-500">E-commerce Solutions</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset delivers expert Shopify e-commerce solutions in **Al
            Barsha**, crafting scalable, user-friendly online stores to drive
            sales and growth. Leverage Shopify’s powerful platform with our
            tailored expertise.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce website on laptop
          "https://images.unsplash.com/photo-1661956602944-249bcd04b63f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Shopify logo and brand
          "https://images.unsplash.com/photo-1577401158266-39c8a0e37d58?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Shopify Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Our Shopify Solutions?</Subheading>}
        heading="Top Shopify Development in Al Barsha"
        description="We build Shopify stores that convert and scale."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Custom Shopify Design",
            description: "Unique stores tailored to your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Launch quickly with Shopify’s tools.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "App Integrations",
            description: "Access 13,000+ Shopify apps for flexibility.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Checkout",
            description: "Shopify Checkout boosts conversions by 15%.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized",
            description: "Seamless shopping on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Local Expertise",
            description: "Al Barsha’s trusted Shopify partner.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Build</Subheading>}
        heading="Our Shopify Development Process"
        description={
          <Description>
            We create your Shopify store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Align with your business goals.</li>
              <li>Design: Craft engaging, brand-focused themes.</li>
              <li>Development: Integrate apps and payment systems.</li>
              <li>Optimization: Enhance SEO and performance.</li>
              <li>Launch: Deploy your store for success.</li>
              <li>Support: Offer ongoing maintenance and scaling.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1590935217180-77701fc6b476?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce development process
          "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team working on digital projects
          "https://images.unsplash.com/photo-1523726491678-bf852e717f6a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Product photography for e-commerce
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Shopify Success in Al Barsha"
        description="Our stores empower businesses to thrive."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Boost",
            description: "Increased sales by 140% in 3 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Launch",
            description: "Store live in under 7 days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% positive feedback.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell?</Subheading>}
        heading="Shopify E-commerce Solutions in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for top-tier Shopify e-commerce
            solutions in Al Barsha. Launch a store that converts—contact us
            today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321165247-4aa89a48be28?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Successful business team
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Woman happily using laptop for online shopping
          "https://images.unsplash.com/photo-1561069934-eee225952461?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
